/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard PRO React Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size } = typography;

const getButtonColors = (mode) => {
  const palette = colors[mode] || colors.light;
  return {
    transparent: palette.transparent,
    light: palette.light,
    info: palette.info,
    secondary: palette.secondary,
    text: palette.text,
    primary: palette.primary,
    success: palette.success,
    warning: palette.warning,
    error: palette.error,
    white: palette.white,
  };
};

export default {
  base: ({ theme }) => {
    const mode = theme?.palette?.mode || "light";
    const isDark = mode === "dark";
    const buttonColors = getButtonColors(mode);

    return {
      minHeight: pxToRem(42),
      color: buttonColors.text.primary,
      borderColor: buttonColors.text.primary,
      borderWidth: "2px",
      padding: `${pxToRem(12)} ${pxToRem(24)}`,
      backgroundColor: buttonColors.transparent.main,
      fontWeight: 600,

      "&:hover": {
        backgroundColor: buttonColors.transparent.main,
        borderColor: isDark ? buttonColors.white.main : buttonColors.text.primary,
        borderWidth: "2px",
      },

      "&:focus:not(:hover)": {
        boxShadow: `0 0 0 3px ${buttonColors.text.primary}30`,
      },

      "& .material-icon, .material-icons-round, svg": {
        fontSize: `${pxToRem(16)}`,
      },
    };
  },

  small: {
    minHeight: pxToRem(34),
    padding: `${pxToRem(8)} ${pxToRem(32)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)}`,
    },
  },

  large: {
    minHeight: pxToRem(49),
    padding: `${pxToRem(14)} ${pxToRem(64)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: ({ theme }) => {
    const mode = theme?.palette?.mode || "light";
    const buttonColors = getButtonColors(mode);

    return {
      backgroundColor: buttonColors.transparent.main,
      borderColor: buttonColors.primary.main,
      color: buttonColors.primary.main,
      borderWidth: "2px",

      "&:hover": {
        backgroundColor: buttonColors.transparent.main,
        borderColor: buttonColors.primary.focus,
        color: buttonColors.primary.focus,
        borderWidth: "2px",
      },

      "&:focus:not(:hover)": {
        boxShadow: `0 0 0 3px ${buttonColors.primary.main}40`,
      },
    };
  },

  secondary: ({ theme }) => {
    const mode = theme?.palette?.mode || "light";
    const buttonColors = getButtonColors(mode);
    const hoverColor = mode === "dark" ? "#00897b" : "#00695c";

    return {
      backgroundColor: buttonColors.transparent.main,
      borderColor: buttonColors.secondary.main,
      color: buttonColors.secondary.main,
      borderWidth: "2px",

      "&:hover": {
        backgroundColor: buttonColors.transparent.main,
        borderColor: hoverColor,
        color: hoverColor,
        borderWidth: "2px",
      },

      "&:focus:not(:hover)": {
        boxShadow: `0 0 0 3px ${buttonColors.secondary.main}40`,
      },
    };
  },
};
